
import type {
    YMap, 
    DomEvent,
    DomEventHandlerObject,
} from '@yandex/ymaps3-types'

import { defineComponent } from 'vue'

import YandexMap3 from '@/modules/YandexMap3Module/components/YandexMap3/index.vue'

const YANDEX_MAP_SCRIPT_SRC = process.env.VUE_APP_MAP_3_SCRIPT_URL!

export default defineComponent({
    components: {
        'yandex-map-3': YandexMap3,
    },
    emits: ['map-ready', 'map-destroyed', 'map-clicked'],
    setup(props, { emit }) {
        const onMapReady = (createdMap: YMap) => {
            emit('map-ready', createdMap)
        }

        const onMapDestroyed = () => {
            emit('map-destroyed')
        }

        const onMapClicked = (options: { object: DomEventHandlerObject; event: DomEvent }) => {
            emit('map-clicked', options)
        }

        return {
            YANDEX_MAP_SCRIPT_SRC,
            onMapReady,
            onMapDestroyed,
            onMapClicked
        }
    }
})
